import React, { forwardRef } from 'react'
import { PropTypes } from 'prop-types'
import DataConfirmation from '../DataConfirmation'
import ContainerFields from './ContainerFields'

const Confirmation = forwardRef((props, ref) => {
  const { quotation } = props
  return (
    <>
      <DataConfirmation
        ref={ref}
        {...props}
      >
        <ContainerFields quotation={quotation} />
      </DataConfirmation>
    </>
  )
})

Confirmation.propTypes = {
  quotation: PropTypes.any.isRequired,
}

export default Confirmation
